<template>
  <picture :class="['picture has-aspect-ratio', customClass]" v-if="isDesktop">
    <source
      :media="devicewidth(data.width)"
      :data-srcset="data.src"
      v-for="(data, index) in pictureData.srcset"
      :key="index"
    />
    <img
      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      :data-src="pictureData.src"
      :alt="pictureData.alt"
      class="lazy"
      decoding="async"
    />
  </picture>
</template>

<script>
export default {
  name: 'picture-block',
  props: {
    customClass: {
      default: 'is-16by9-desktop is-1by1-mobile',
      type: String,
    },
    pictureData: {
      type: Object,
    },
    isMobile: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      isDesktop: true,
    };
  },
  methods: {
    devicewidth(width) {
      if (width == '360') {
        return '(max-width: 767px)';
      } else if (width == '720') {
        return '(min-width: 768px) and (max-width: 1199px)';
      } else {
        return '(min-width: 1200px)';
      }
    },
    checkScreenSize() {
      if (!this.isMobile) {
        this.isDesktop = window.innerWidth >= 768;
      }
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
};
</script>
